import { z } from 'zod';

import { ZodBusinessUserInvestmentObjectives } from '@Common/types/bo_wm/customers/create_business_customer';
import { ZodPersonalUserInvestmentObjectives } from '@Common/types/bo_wm/customers/create_customer';

export const ZodUserInvestmentObjectiveMerged = z.enum([
  ...ZodPersonalUserInvestmentObjectives.element.options,
  ...ZodBusinessUserInvestmentObjectives.element.options,
]);

export type UserInvestmentObjectiveMergedType = z.infer<typeof ZodUserInvestmentObjectiveMerged>;

export const ZodUserInvestmentObjectives = ZodUserInvestmentObjectiveMerged.array();
